import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-menu-toggle',
  standalone: false,
  templateUrl: './menu-toggle.component.html',
  styleUrl: './menu-toggle.component.scss',
})
export class MenuToggleComponent {
  @Input() isOpen = false;
  @Input() controlsId = '';
  @Input() showLabel = true;
  @Input() flatStyle = false;
  @Output() toggle = new EventEmitter<void>();

  onToggle(event: Event): void {
    event.stopPropagation(); // Prevent event bubbling
    this.toggle.emit();
  }
}
